import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1mhxgl7b: FaireBrandEntity = {
  token: "b_1mhxgl7b",
  type: "brand",
  name: "Dear Heart",
  avatarUrl:
    "https://cdn.faire.com/fastly/f5449a756cea18bca5ec3d5e0ce390906b5b1ef41503db93bbe0de0e8b129685.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/355694316252a9899cd991589e8feb7b6d38c0b44943d1a8b433d98bfb49822f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f5449a756cea18bca5ec3d5e0ce390906b5b1ef41503db93bbe0de0e8b129685.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/355694316252a9899cd991589e8feb7b6d38c0b44943d1a8b433d98bfb49822f.jpeg",
  location: "Wichita Falls, TX, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 274,
  isTopShop: true,
  isInsider: true,
  description:
    "In 2013 shortly after graduating college, our founder Nichole had the idea to create bracelets to help fund a friend going on a mission trip. After an overwhelming response on the first day, her friend was fully funded. Hours after handing over the donation check, she received a sale for the exact amount from a stranger across the country. She knew then that this was the path that God had for her. Through one small act of obedience, God opened the door for her to create Dear Heart, a ministry that is now impacting thousands around the world.\n\nAt Dear Heart, we believe that something as simple as a delicate necklace can make a massive impact. Our hope is that when you hold this piece in your hands, you’re reminded of the truth that it represents. As you put it around your neck, you’re equipped with an intentional tool to have the deep, vulnerable conversations because those are really the ones that matter most. Our prayer is that these pieces can bring hope to the lost, revival to the weary, and courage for the believer.\n \n\nSo go sister, the world needs your open heart and bright soul.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.118Z",
    importedBy: "entity-db-cli",
  },
};
